import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { Subject, takeUntil } from 'rxjs';
//import { Config } from "./../../../../helpers/config.helper"; // declare const config: any;
import { MenuAssist } from "./../../../../helpers/menu-assist.helper"; // declare const Helpers: any;
import { Menu } from "./../../../../helpers/menu.helper"; // declare const Menu: any;

class SidebarItem {
  constructor(id: number, label: string, icon: string, route: string | null, childItems: SidebarItem[] = [], iconColor: string = null, showChild: boolean = false,moduleKey: string = '', allowedRoles: string[] = []) {
    this.id = id;
    this.label = label;
    this.icon = icon;
    this.iconColor = iconColor;
    this.route = route;
    this.showChild = showChild;
    this.childItems = childItems;
    this.moduleKey = moduleKey;
    this.allowedRoles = allowedRoles;
  }
  id: number = 0;
  label: string = '';
  icon: string = '';
  iconColor: string = '';
  route: string | null = '';
  showChild: boolean = false;
  isActive: boolean = false;
  isOpen: boolean = false;
  childItems: SidebarItem[] = [];
  moduleKey: string = '';
  allowedRoles: string[] = [];
}
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [NgScrollbarModule,RouterModule,CommonModule]
})
export class SidebarComponent {
  //#region Variables Declaration
  public menuAssist: MenuAssist = new MenuAssist();
  protected ngUnsubscribe$: Subject<void> = new Subject<void>();
  public userModules: { [key: string]: { read: boolean } } = {};
  public role_name: string = ''
  public current_href: string = "";
  public selected_route: string = "";
  public isMenuFixed: boolean = true;

  public controlSystem: SidebarItem[] = [
    new SidebarItem(1, 'SADIN Control Board', '', 'appliance/control-board/control', [], null, false, 'Control'),
    new SidebarItem(2, 'Smart Controls', '', 'appliance/control-board/smart-controls', [], null, false, 'Control'),
    new SidebarItem(4, 'Live Demo', '', 'appliance/live-demo', [], null, false, 'Control'),
    new SidebarItem(4, '2D Floor Plan', '', 'appliance/control-board/floor-plan', [], null, false, 'Control'),
  ];

  public scheduleManagement: SidebarItem[] = [
    new SidebarItem(1, 'Schedule List', '', 'schedule-management/schedule-list', [], null, false, 'Schedule'),
    new SidebarItem(2, 'Schedule Overview', '', 'schedule-management/schedule-overview', [], null, false, 'Schedule'),
  ];

  public energy: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'energy/overview', [], null, false, 'Energy'),
    // new SidebarItem(2, 'Administrative Dashboard', '', 'energy/administrative-dashboard', [], null, false, 'EnergyAdmin'),
    new SidebarItem(3, 'Energy Report', '', 'energy/energy-report', [], null, false, 'Energy'),
    new SidebarItem(4, 'Consumption Report', '', 'energy/consumption-report', [], null, false, 'EnergyAdmin'),
    // new SidebarItem(4, 'Consumption Breakdown', '', 'energy/consumption-breakdown', [], null, false, 'Energy'),),
    new SidebarItem(5, 'Units Energy Usage', '', 'energy/units-energy-usage', [], null, false, 'Energy'),
  ];
  public water: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'water/overview', [], null, false, 'Water'),
    new SidebarItem(2, 'Water Report', '', 'water/water-report', [], null, false, 'Water'),
    new SidebarItem(3, 'Consumption Breakdown', '', 'water/consumption-breakdown', [], null, false, 'Water'),
    new SidebarItem(4, 'Units Water Usage', '', 'water/units-water-usage', [], null, false, 'Water'),
  ];
  public solarManagement: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'solar-management/overview'),
    new SidebarItem(2, 'Solar Panels', '', 'solar-management/solar-panels'),
    new SidebarItem(3, 'Reports', '', 'solar-management/reports'),
  ];
  public mosqueManagement: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'mosque-management/overview', [], null, false),
    new SidebarItem(2, 'Prayer Overview', '', 'mosque-management/prayer-overview', [], null, false),
    new SidebarItem(3, 'Prayer Time', '', 'mosque-management/prayer-time', [], null, false),
  ];
  public environment: SidebarItem[] = [
    new SidebarItem(1, 'Overview', '', 'environment/overview',[], null, false, 'Environment'),
    new SidebarItem(2, 'Indoor ENV Analysis', '', 'environment/indoor-env-analysis', [], null, false, 'Environment'),
    new SidebarItem(3, 'Consumption ENV Breakdown', '', 'environment/consumption-env-breakdown', [], null, false, 'Environment'),
  ];
  public fireAlarmSystem: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'fire-alarm/system-health', [], null, false, 'Fire'),
    new SidebarItem(2, 'Maintenance Schedule', '', 'fire-alarm/maintenance-schedule', [], null, false, 'Fire'),
    new SidebarItem(3, 'Errors & Warning logs', '', 'fire-alarm/errors-warning-logs', [], null, false, 'Fire'),
  ];
  public hvac: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'hvac/system-health', [], null, false, 'HVAC'),
    new SidebarItem(2, 'Maintenance Schedule', '', 'hvac/maintenance-schedule', [], null, false, 'HVAC'),
    new SidebarItem(3, 'Errors & Warning logs', '', 'hvac/errors-warning-logs', [], null, false, 'HVAC'),
  ];
  public liftsSystem: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'lift-system/system-health', [], null, false, 'Lift'),
    new SidebarItem(2, 'Maintenance Schedule', '', 'lift-system/maintenance-schedule', [], null, false, 'Lift'),
    new SidebarItem(3, 'Errors & Warning logs', '', 'lift-system/errors-warning-logs', [], null, false, 'Lift'),
  ];
  public accessControlEss: SidebarItem[] = [
    new SidebarItem(1, 'Dashboard / My Requests', '', 'access-control/ess-dashboard', [], null, false, 'Access'),
    new SidebarItem(2, 'Visitor Access Request', '', 'access-control/visitor-access-request', [], null, false, 'Access'),
    new SidebarItem(3, 'Restricted Zone Access Request', '', 'access-control/restricted-zone-request', [], null, false, 'Access'),
    new SidebarItem(4, 'Space Booking Form', '', 'access-control/space-booking-form', [], null, false, 'Access'),
    new SidebarItem(5, 'Overtime Power Request', '', 'access-control/overtime-power-request', [], null, false, 'Access'),
    new SidebarItem(6, 'My Bookings & Access History', '', 'access-control/my-bookings-history', [], null, false, 'Access'),
    new SidebarItem(7, 'Notifications Center', '', 'access-control/notifications-center', [], null, false, 'Access'),
  ];
  public accessControlSupervisor: SidebarItem[] = [
    new SidebarItem(1, 'Requests Inbox / Pending Approvals', '', 'access-control/requests-inbox', [], null, false, 'Access'),
    new SidebarItem(2, 'Request Detail / Decision View', '', 'access-control/request-decision', [], null, false, 'Access'),
    new SidebarItem(3, 'Delegation / Proxy Access', '', 'access-control/delegation-proxy', [], null, false, 'Access'),
  ];
  public accessControlManagement: SidebarItem[] = [
    new SidebarItem(1, 'Access Points Management', '', 'access-control/access-points', [], null, false, 'Access'),
    new SidebarItem(2, 'Zones Management', '', 'access-control/zones', [], null, false, 'Access'),
    new SidebarItem(3, 'Access Schedules', '', 'access-control/access-schedules', [], null, false, 'Access'),
    new SidebarItem(4, 'Access Groups / Roles', '', 'access-control/access-groups', [], null, false, 'Access'),
    new SidebarItem(5, 'Device Commissioning / Status', '', 'access-control/device-commissioning', [], null, false, 'Access'),
    new SidebarItem(6, 'Credential Management', '', 'access-control/credentials', [], null, false, 'Access'),
    new SidebarItem(7, 'Access Logs / Audit Trail', '', 'access-control/access-logs', [], null, false, 'Access'),
    new SidebarItem(8, 'Emergency Unlock / Fail-Safe Panel', '', 'access-control/emergency-unlock', [], null, false, 'Access'),
  ];
  public accessControlSpaceManagement: SidebarItem[] = [
    new SidebarItem(1, 'Spaces Directory', '', 'access-control/spaces-directory', [], null, false, 'Access'),
    new SidebarItem(2, 'Space Details / Edit', '', 'access-control/space-detail', [], null, false, 'Access'),
    new SidebarItem(3, 'Booking Calendar / Timeline', '', 'access-control/booking-calendar', [], null, false, 'Access'),
    new SidebarItem(4, 'Booking Approvals / Conflicts', '', 'access-control/booking-approvals', [], null, false, 'Access'),
    new SidebarItem(5, 'Space Utilization Analytics', '', 'access-control/space-utilization', [], null, false, 'Access'),
  ];
  public accessControlOccupancy: SidebarItem[] = [
    new SidebarItem(1, 'Occupancy Dashboard', '', 'access-control/occupancy-dashboard', [], null, false, 'Access'),
    new SidebarItem(2, 'Occupancy Sensors Management', '', 'access-control/occupancy-sensors', [], null, false, 'Access'),
    new SidebarItem(3, 'Zone Capacity Setup', '', 'access-control/zone-capacity', [], null, false, 'Access'),
    new SidebarItem(4, 'Occupancy History & Reports', '', 'access-control/occupancy-history', [], null, false, 'Access'),
  ];
  public accessControlAlerts: SidebarItem[] = [
    new SidebarItem(1, 'Alert Policies Builder', '', 'access-control/alert-policies', [], null, false, 'Access'),
    new SidebarItem(2, 'Alert Routing Matrix', '', 'access-control/alert-routing', [], null, false, 'Access'),
    new SidebarItem(3, 'Alerts Inbox / Acknowledge', '', 'access-control/alerts-inbox', [], null, false, 'Access'),
    new SidebarItem(4, 'Escalation Rules / SLA Settings', '', 'access-control/escalation-rules', [], null, false, 'Access'),
  ];
  public accessControlCommandCenters: SidebarItem[] = [
    new SidebarItem(1, 'CCC Dashboard', '', 'access-control/ccc-dashboard', [], null, false, 'Access'),
    new SidebarItem(2, 'CSC Dashboard / Video Wall', '', 'access-control/csc-video-wall', [], null, false, 'Access'),
    new SidebarItem(3, 'Zone Overview Map', '', 'access-control/zone-map', [], null, false, 'Access'),
    new SidebarItem(4, 'Incident Review / Evidence', '', 'access-control/incident-review', [], null, false, 'Access'),
  ];
  public accessControlAdministration: SidebarItem[] = [
    new SidebarItem(1, 'Form Builder / Schema Editor', '', 'access-control/form-builder', [], null, false, 'Access'),
    new SidebarItem(2, 'Policy Management', '', 'access-control/policy-management', [], null, false, 'Access'),
    new SidebarItem(3, 'Department Management', '', 'access-control/departments', [], null, false, 'Access'),
    new SidebarItem(4, 'Access Methods Setup', '', 'access-control/access-methods', [], null, false, 'Access'),
    new SidebarItem(5, 'User Roles & Permissions', '', 'access-control/roles-permissions', [], null, false, 'Access'),
    new SidebarItem(6, 'Audit Logs / System Events', '', 'access-control/audit-logs', [], null, false, 'Access'),
    new SidebarItem(7, 'Integration Settings', '', 'access-control/integrations', [], null, false, 'Access'),
    new SidebarItem(8, 'Localization / Language', '', 'access-control/localization', [], null, false, 'Access'),
    new SidebarItem(9, 'System Configuration / Global Parameters', '', 'access-control/system-config', [], null, false, 'Access'),
  ];
  public accessControlReports: SidebarItem[] = [
    new SidebarItem(1, 'Access Activity Report', '', 'access-control/access-activity-report', [], null, false, 'Access'),
    new SidebarItem(2, 'Space Utilization Report', '', 'access-control/space-utilization-report', [], null, false, 'Access'),
    new SidebarItem(3, 'Incident / Alert Summary', '', 'access-control/incident-alert-summary', [], null, false, 'Access'),
    new SidebarItem(4, 'System Health / Device Status', '', 'access-control/system-health', [], null, false, 'Access'),
  ];
  public accessControlSupport: SidebarItem[] = [
    new SidebarItem(1, 'Helpdesk / Knowledge Base', '', 'access-control/knowledge-base', [], null, false, 'Access'),
    new SidebarItem(2, 'Tickets / Support Requests', '', 'access-control/tickets', [], null, false, 'Access'),
  ];
  public accessControlSystem: SidebarItem[] = [
    new SidebarItem(1, 'ESS / SSP Portal', '', '', this.accessControlEss, null, false, 'Access'),
    new SidebarItem(2, 'Supervisor / Manager', '', '', this.accessControlSupervisor, null, false, 'Access'),
    new SidebarItem(3, 'Access Control Management', '', '', this.accessControlManagement, null, false, 'Access'),
    new SidebarItem(4, 'Space Management', '', '', this.accessControlSpaceManagement, null, false, 'Access'),
    new SidebarItem(5, 'Occupancy Monitoring', '', '', this.accessControlOccupancy, null, false, 'Access'),
    new SidebarItem(6, 'Alerts & Policies', '', '', this.accessControlAlerts, null, false, 'Access'),
    new SidebarItem(7, 'CCC & CSC', '', '', this.accessControlCommandCenters, null, false, 'Access'),
    new SidebarItem(8, 'Administration & Settings', '', '', this.accessControlAdministration, null, false, 'Access'),
    new SidebarItem(9, 'Reports & Analytics', '', '', this.accessControlReports, null, false, 'Access'),
    new SidebarItem(10, 'Support & Helpdesk', '', '', this.accessControlSupport, null, false, 'Access'),
  ];
  public occupancy: SidebarItem[] = [
    new SidebarItem(1, 'Live Monitoring', '', 'occupancy/live-monitoring', [], null, false, 'Occupancy'),
    new SidebarItem(2, 'Occupancy by Zone', '', 'occupancy/by-zone', [], null, false, 'Occupancy'),
    new SidebarItem(3, 'Zone management', '', 'occupancy/zone-management', [], null, false, 'Occupancy'),
  ];
  public parking: SidebarItem[] = [
    new SidebarItem(1, 'System Health', '', 'parking/system-health', [], null, false, 'Parking'),
    new SidebarItem(2, 'Vehicle Management', '', 'parking/vehicle-management', [], null, false, 'Parking'),
    new SidebarItem(3, 'Vehicle Category', '', 'parking/vehicle-category', [], null, false, 'Parking'),
    new SidebarItem(4, 'Parking map', '', 'parking/parking-map', [], null, false, 'Parking'),
    new SidebarItem(5, 'Access Report', '', 'parking/access-report', [], null, false, 'Parking'),
  ];
  public assetManagement: SidebarItem[] = [
    new SidebarItem(1, 'Facility', '', 'asset/facility', [], null, false, 'Assets', ['owner', 'SADIN-ADMIN']),
    new SidebarItem(3, 'Units', '', 'asset/units', [], null, false, 'Assets'),
    new SidebarItem(2, 'Unit Type', '', 'asset/unit-type', [], null, false, 'Assets'),
  ];
  public networkManagement: SidebarItem[] = [
    new SidebarItem(1, 'Network Status', '', 'network/status', [], null, false, 'Network'),
    new SidebarItem(2, 'Network Configuration', '', 'network/configuration', [], null, false, 'Network'),
    new SidebarItem(3, 'Network logs', '', 'network/logs', [], null, false, 'Network'),
  ];
  public preventiveMaintenance: SidebarItem[] = [
    new SidebarItem(1, 'Asset Management & Registry', '', '', [
      new SidebarItem(1, 'Asset Registry List', '', 'preventive-maintenance/assets/asset-registry-list'),
      new SidebarItem(2, 'Asset Lifecycle Management', '', 'preventive-maintenance/assets/asset-lifecycle'),
      new SidebarItem(3, 'Asset Category Management', '', 'preventive-maintenance/assets/asset-categories'),
      new SidebarItem(4, 'Asset Hierarchy View', '', 'preventive-maintenance/assets/asset-hierarchy'),
      new SidebarItem(5, 'Asset Location Mapping', '', 'preventive-maintenance/assets/asset-location-mapping'),
      new SidebarItem(6, 'Asset Documents', '', 'preventive-maintenance/assets/asset-documents'),
      new SidebarItem(7, 'Asset Warranty View', '', 'preventive-maintenance/assets/asset-warranty'),
      new SidebarItem(8, 'Asset Maintenance History', '', 'preventive-maintenance/assets/asset-maintenance-history'),
      new SidebarItem(9, 'Asset Import', '', 'preventive-maintenance/assets/asset-import'),
      new SidebarItem(10, 'Asset Import Review', '', 'preventive-maintenance/assets/import-review'),
      new SidebarItem(11, 'Asset Audit Trail', '', 'preventive-maintenance/assets/asset-audit-trail'),
    ]),
    new SidebarItem(2, 'Preventive Maintenance', '', '', [
      new SidebarItem(1, 'PM Dashboard', '', 'preventive-maintenance/pm/pm-dashboard'),
      new SidebarItem(2, 'PM Template List', '', 'preventive-maintenance/pm/pm-template-list'),
      new SidebarItem(3, 'PM Template Version History', '', 'preventive-maintenance/pm/pm-template-versions'),
      new SidebarItem(4, 'PM Plan List', '', 'preventive-maintenance/pm/pm-plan-list'),
      new SidebarItem(5, 'PM Calendar', '', 'preventive-maintenance/pm/pm-calendar'),
      new SidebarItem(6, 'PM Scheduler Monitor', '', 'preventive-maintenance/pm/pm-scheduler-monitor'),
      new SidebarItem(7, 'PM Compliance Report', '', 'preventive-maintenance/pm/pm-compliance-report'),
      new SidebarItem(8, 'PM History', '', 'preventive-maintenance/pm/pm-history'),
      new SidebarItem(9, 'PM Execution View', '', 'preventive-maintenance/pm/pm-execution'),
    ]),
    new SidebarItem(3, 'Work Order Management', '', '', [
      new SidebarItem(1, 'WO Dashboard', '', 'preventive-maintenance/work-orders/wo-dashboard'),
      new SidebarItem(2, 'Work Request List', '', 'preventive-maintenance/work-orders/work-request-list'),
      new SidebarItem(3, 'Submit Work Request', '', 'preventive-maintenance/work-orders/submit-work-request'),
      new SidebarItem(4, 'Work Request Review', '', 'preventive-maintenance/work-orders/work-request-review'),
      new SidebarItem(5, 'WO List', '', 'preventive-maintenance/work-orders/wo-list'),
      new SidebarItem(6, 'WO Assignment', '', 'preventive-maintenance/work-orders/wo-assignment'),
      new SidebarItem(7, 'Technician Work Queue', '', 'preventive-maintenance/work-orders/technician-queue'),
      new SidebarItem(8, 'WO Execution', '', 'preventive-maintenance/work-orders/wo-execution'),
      new SidebarItem(9, 'WO Checklist', '', 'preventive-maintenance/work-orders/wo-checklist'),
      new SidebarItem(10, 'WO Time Logs', '', 'preventive-maintenance/work-orders/wo-time-logs'),
      new SidebarItem(11, 'WO Parts Usage', '', 'preventive-maintenance/work-orders/wo-parts-usage'),
      new SidebarItem(12, 'WO Attachments', '', 'preventive-maintenance/work-orders/wo-attachments'),
      new SidebarItem(13, 'WO Approval', '', 'preventive-maintenance/work-orders/wo-approval'),
      new SidebarItem(14, 'WO Closure', '', 'preventive-maintenance/work-orders/wo-closure'),
      new SidebarItem(15, 'WO Reopen', '', 'preventive-maintenance/work-orders/wo-reopen'),
      new SidebarItem(16, 'WO Cost Summary', '', 'preventive-maintenance/work-orders/wo-cost-summary'),
      new SidebarItem(17, 'SLA and Escalation View', '', 'preventive-maintenance/work-orders/sla-escalation'),
      new SidebarItem(18, 'WO History', '', 'preventive-maintenance/work-orders/wo-history'),
    ]),
    new SidebarItem(4, 'Inventory & Spare Parts', '', '', [
      new SidebarItem(1, 'INV Dashboard', '', 'preventive-maintenance/inventory/inv-dashboard'),
      new SidebarItem(2, 'Item Master List', '', 'preventive-maintenance/inventory/item-master-list'),
      new SidebarItem(3, 'Warehouse List', '', 'preventive-maintenance/inventory/warehouse-list'),
      new SidebarItem(4, 'Stock Balance View', '', 'preventive-maintenance/inventory/stock-balance'),
      new SidebarItem(5, 'Stock-In', '', 'preventive-maintenance/inventory/stock-in'),
      new SidebarItem(6, 'Stock-Out', '', 'preventive-maintenance/inventory/stock-out'),
      new SidebarItem(7, 'Stock Reservation', '', 'preventive-maintenance/inventory/stock-reservation'),
      new SidebarItem(8, 'Return Parts', '', 'preventive-maintenance/inventory/return-parts'),
      new SidebarItem(9, 'Stock Transfer', '', 'preventive-maintenance/inventory/stock-transfer'),
      new SidebarItem(10, 'Stock Adjustment', '', 'preventive-maintenance/inventory/stock-adjustment'),
      new SidebarItem(11, 'Adjustment Approval', '', 'preventive-maintenance/inventory/adjustment-approval'),
      new SidebarItem(12, 'Transaction History', '', 'preventive-maintenance/inventory/transaction-history'),
      new SidebarItem(13, 'Low-Stock Report', '', 'preventive-maintenance/inventory/low-stock-report'),
      new SidebarItem(14, 'Out-of-Stock Report', '', 'preventive-maintenance/inventory/out-of-stock-report'),
      new SidebarItem(15, 'Spare Parts Usage Report', '', 'preventive-maintenance/inventory/spare-parts-usage-report'),
      new SidebarItem(16, 'INV Cost Report', '', 'preventive-maintenance/inventory/inv-cost-report'),
      new SidebarItem(17, 'Stock Reconciliation / Cycle Count', '', 'preventive-maintenance/inventory/stock-reconciliation'),
    ]),
    new SidebarItem(5, 'Dashboards & Reports', '', '', [
      new SidebarItem(1, 'Maintenance Executive Dashboard', '', 'preventive-maintenance/reports/executive-dashboard'),
      new SidebarItem(2, 'Asset Dashboard', '', 'preventive-maintenance/reports/asset-dashboard'),
      new SidebarItem(3, 'PM KPI Dashboard', '', 'preventive-maintenance/reports/pm-kpi-dashboard'),
      new SidebarItem(4, 'WO KPI Dashboard', '', 'preventive-maintenance/reports/wo-kpi-dashboard'),
      new SidebarItem(5, 'INV KPI Dashboard', '', 'preventive-maintenance/reports/inv-kpi-dashboard'),
      new SidebarItem(6, 'Asset Cost Report', '', 'preventive-maintenance/reports/asset-cost-report'),
      new SidebarItem(7, 'Downtime Report', '', 'preventive-maintenance/reports/downtime-report'),
      new SidebarItem(8, 'Technician Performance Report', '', 'preventive-maintenance/reports/technician-performance'),
      new SidebarItem(9, 'SLA Compliance Report', '', 'preventive-maintenance/reports/sla-compliance-report'),
      new SidebarItem(10, 'Export Center', '', 'preventive-maintenance/reports/export-center'),
    ]),
    new SidebarItem(6, 'Settings & Configuration', '', '', [
      new SidebarItem(1, 'Maintenance Module Settings', '', 'preventive-maintenance/settings/module-settings'),
      new SidebarItem(2, 'Asset Settings', '', 'preventive-maintenance/settings/asset-settings'),
      new SidebarItem(3, 'PM Settings', '', 'preventive-maintenance/settings/pm-settings'),
      new SidebarItem(4, 'WO Settings', '', 'preventive-maintenance/settings/wo-settings'),
      new SidebarItem(5, 'INV Settings', '', 'preventive-maintenance/settings/inv-settings'),
      new SidebarItem(6, 'Notification Settings', '', 'preventive-maintenance/settings/notification-settings'),
      new SidebarItem(7, 'Audit and Monitoring Settings', '', 'preventive-maintenance/settings/audit-monitoring-settings'),
      new SidebarItem(8, 'File and Attachment Settings', '', 'preventive-maintenance/settings/file-attachment-settings'),
      new SidebarItem(9, 'Analytics and Reporting Settings', '', 'preventive-maintenance/settings/analytics-reporting-settings'),
      new SidebarItem(10, 'Integration and API Settings', '', 'preventive-maintenance/settings/integration-api-settings'),
      new SidebarItem(11, 'Role and Permission Settings', '', 'preventive-maintenance/settings/role-permission-settings'),
      new SidebarItem(12, 'Configuration Audit Trail', '', 'preventive-maintenance/settings/configuration-audit-trail'),
    ]),
    new SidebarItem(7, 'Shared & Cross-Module', '', '', [
      new SidebarItem(1, 'Global Search', '', 'preventive-maintenance/shared/global-search'),
      new SidebarItem(2, 'Notification Center', '', 'preventive-maintenance/shared/notification-center'),
      new SidebarItem(3, 'My Tasks', '', 'preventive-maintenance/shared/my-tasks'),
      new SidebarItem(4, 'My Approvals', '', 'preventive-maintenance/shared/my-approvals'),
      new SidebarItem(5, 'Attachment Viewer', '', 'preventive-maintenance/shared/attachment-viewer'),
      new SidebarItem(6, 'Audit Log Viewer', '', 'preventive-maintenance/shared/audit-log-viewer'),
      new SidebarItem(7, 'Activity Timeline', '', 'preventive-maintenance/shared/activity-timeline'),
      new SidebarItem(8, 'User Profile Preferences', '', 'preventive-maintenance/shared/user-preferences'),
      new SidebarItem(9, 'Help and User Guide', '', 'preventive-maintenance/shared/help-guide'),
      new SidebarItem(10, 'Error and Validation Summary', '', 'preventive-maintenance/shared/validation-summary'),
    ]),
  ];
  public rolesAndPermissions: SidebarItem[] = [
    new SidebarItem(1, 'Roles', '', 'system-settings/role-permission/role'),
    new SidebarItem(2, 'Permission', '', 'system-settings/role-permission/permission'),
  ];
  public authentications: SidebarItem[] = [
    new SidebarItem(1, 'MFA', '', 'system-settings/authentication/mfa', [], null, false, 'Authentication'),
  ];
  public api: SidebarItem[] = [
    new SidebarItem(1, 'API Logs', '', 'system-settings/api/api-logs', [], null, false, 'API'),
    new SidebarItem(2, 'API Usage', '', 'system-settings/api/api-usage', [], null, false, 'API'),
  ];
  public appliances: SidebarItem[] = [
    new SidebarItem(1, 'Appliances List', '', 'system-settings/appliances', [], null, false, 'Appliances'),
    new SidebarItem(2, 'Appliances Categories', '', 'system-settings/appliance-category', [], null, false, 'Appliances'),
  ];
  public deviceManagement: SidebarItem[] = [
    new SidebarItem(1, 'Devices List', '', 'system-settings/device/devices-list', [], null, false, 'Device'),
    new SidebarItem(2, 'Device Categories', '', 'system-settings/device/device-categories', [], null, false, 'Device'),
    new SidebarItem(3, 'Device Types', '', 'system-settings/device/device-types', [], null, false, 'Device'),
    new SidebarItem(4, 'Auto / Manual Status', '', 'system-settings/device/auto-manual-status', [], null, false, 'Device'),
    new SidebarItem(5, 'Syslog', '', 'system-settings/device/syslog', [], null, false, 'Device'),
    new SidebarItem(6, 'Connection Log', '', 'system-settings/device/connection-log', [
      new SidebarItem(1, 'MQTT Log', '', 'system-settings/device/connection-log/mqtt-log', [], null, false, 'Device'),
      new SidebarItem(2, 'SRTP Log', '', 'system-settings/device/connection-log/srtp-log', [], null, false, 'Device'),
    ], null, false, 'Device'),
  ];
  public user: SidebarItem[] = [
    new SidebarItem(1, 'Users List', '', 'system-settings/users', [], null, false, 'User'),
    new SidebarItem(2, 'Roles & Permissions', '', 'system-settings/role-permission', [], null, false, 'User'),
    new SidebarItem(3, 'Authentications', '', 'system-settings/authentication', [], null, false, 'User'),
    new SidebarItem(4, 'Contacts', '', 'system-settings/contacts', [], null, false, 'User'),
    new SidebarItem(5, 'User Log', '', 'system-settings/activity-logs', [], null, false, 'Logs'),
  ]
  public adminSettings: SidebarItem[] = [
    new SidebarItem(0, 'Firmware Settings', '', 'system-settings/firmware', [], null, false, 'SystemAdmin'),
    new SidebarItem(1, 'MQTT Auth Settings', '', 'system-settings/mqttauth', [], null, false, 'SystemAdmin'),
    new SidebarItem(2, 'Dropdown Settings', '', 'system-settings/dropdown-settings', [], null, false, 'SystemAdmin'),
  ]

   public comingSoon: SidebarItem[] = [
    new SidebarItem(1, 'Third-party Controls', 'fa-solid fa-microchip', 'appliance/control-board/third-party', [], null, false, 'Control'),
    new SidebarItem(2, 'FAS', 'menu-icon fa-duotone fa-fire text-danger', '', this.fireAlarmSystem, null, false, 'Fire'),
    new SidebarItem(3, 'HVAC', 'menu-icon fa-duotone fa-air-conditioner', '', this.hvac, null, false, 'HVAC'),
    new SidebarItem(4, 'Lifts System', 'menu-icon fa-duotone fa-elevator', '', this.liftsSystem, null, false, 'Lift'),
    // new SidebarItem(5, 'Access Control', 'menu-icon fa-duotone fa-universal-access', '', this.accessControlSystem, null, false, 'Access'),
    new SidebarItem(6, 'Occupancy', 'menu-icon fa-duotone fa-people-group me-3', '', this.occupancy, null, false, 'Occupancy'),
    new SidebarItem(7, 'Parking system', 'menu-icon fa-duotone fa-square-parking text-blue', '', this.parking, null, false, 'Parking'),
    new SidebarItem(8, 'Network System', 'menu-icon fa-duotone fa-ethernet', '', this.networkManagement, null, false, 'Network'),
    new SidebarItem(9, 'AI Predictive', 'fa-solid fa-brain', '', [], null, false, ''),
    new SidebarItem(9, 'AI Live Support', 'fa-solid fa-robot', '', [], null, false, ''),
  ];
  public alarmsAndNotifications: SidebarItem[] = [
    new SidebarItem(1, 'Alarms', '', 'alarms/dashboard', [], null, false, 'SystemAdmin'),
    new SidebarItem(2, 'Alarm Acknowledgement', '', 'alarms/acknowledgement', [], null, false, 'SystemAdmin'),
    new SidebarItem(3, 'Alarm Incidents', '', 'alarms/incidents', [], null, false, 'SystemAdmin'),
    new SidebarItem(4, 'Alarm Logs', '', 'alarms/logs', [], null, false, 'SystemAdmin'),
    new SidebarItem(5, 'Notifications', '', 'alarms/notifications', [], null, false, 'SystemAdmin'),
  ];
  public systemSettings: SidebarItem[] = [
    new SidebarItem(0, 'Admin settings', '', 'system-settings/admin-settings', this.adminSettings , null, false, 'SystemAdmin'),
    new SidebarItem(1, 'Homepage Behavior', '', 'system-settings/homepage-behavior'),
    new SidebarItem(2, 'General Setting', '', 'system-settings/general'),
    new SidebarItem(3, 'Energy Setting', '', 'system-settings/energy', [], null, false, 'Energy'),
    new SidebarItem(5, 'Water Setting', '', 'system-settings/water', [], null, false, 'Water'),
    // new SidebarItem(7, 'API', '', 'system-settings/api', this.api, null, null, 'API'),
    // new SidebarItem(8, 'Devices', '', 'system-settings/devices', this.devices),
    // new SidebarItem(9, 'Appliances', '', 'system-settings/appliances', this.appliances, null, null, 'Appliances'),
    // new SidebarItem(10, 'Activity logs', '', 'system-settings/activity-logs', [], null, false, 'Logs'),
  ];
  public sidebarItems: SidebarItem[] = [
    new SidebarItem(0, 'Homepage', 'menu-icon fa-duotone fa-house', 'homepage'),
    new SidebarItem(1, 'Control Board', 'menu-icon fa-duotone fa-plug-circle-bolt text-mediumpurple','', this.controlSystem ,null,null,'Control',),
    new SidebarItem(2, 'Schedule Management', 'menu-icon fa-duotone fa-calendar-days text-info', '', this.scheduleManagement, null, null, 'Schedule'),
    new SidebarItem(3, 'Energy Management', 'menu-icon fa-duotone fa-square-bolt text-warning', '', this.energy, null, null, 'Energy'),
    new SidebarItem(4, 'Solar Management', 'menu-icon fa-duotone fa-solar-panel', '', this.solarManagement, '#f97316'),
    new SidebarItem(5, 'Water Management', 'menu-icon fa-duotone fa-droplet text-info', '', this.water, null, null, 'Water'),
    new SidebarItem(6, 'Mosque Management', 'menu-icon fa-duotone fa-mosque mosque-brown-icon', '', this.mosqueManagement, null, null, 'Mosque'),
    new SidebarItem(7, 'Environment', 'menu-icon fa-duotone fa-seedling text-success', '', this.environment, null, null, 'Environment'),
    // new SidebarItem(5, 'Fire Alarm System', 'menu-icon fa-duotone fa-fire text-danger', '', this.fireAlarmSystem, null, null, 'Fire'),
    // new SidebarItem(6, 'HVAC', 'menu-icon fa-duotone fa-air-conditioner', '', this.hvac, null, null, 'HVAC'),
    // new SidebarItem(7, 'Lifts System', 'menu-icon fa-duotone fa-elevator', '', this.liftsSystem , null, null, 'Lift'),
    new SidebarItem(8, 'Access Control', 'menu-icon fa-duotone fa-universal-access text-success', '', this.accessControlSystem, null, null, 'Access'),
    // new SidebarItem(9, 'Occupancy', 'menu-icon fa-duotone fa-people-group me-3', '', this.occupancy, null, null, 'Occupancy'),
    // new SidebarItem(10, 'Parking Management', 'menu-icon fa-duotone fa-square-parking text-blue', '', this.parking, null, null, 'Parking'),
    new SidebarItem(9, 'Units Management', 'menu-icon fa-duotone fa-building-flag', '', this.assetManagement, '#ff9f43', null, 'Assets'),
    new SidebarItem(10, 'Devices Management', 'menu-icon fa-duotone fa-microchip', '', this.deviceManagement, null, null, 'Device'),

    // new SidebarItem(12, 'Network Management', 'menu-icon fa-duotone fa-ethernet', '', this.networkManagement, '#00917C', null, 'Network'),
    new SidebarItem(11, 'User Management', 'menu-icon fa-duotone fa-users-gear', '', this.user, null, null, 'User'),
    new SidebarItem(12, 'Alarms & Notifications', 'menu-icon fa-duotone fa-bell', 'alarms', this.alarmsAndNotifications, '#dc2626', false, 'Notifications'),
    new SidebarItem(13, 'Preventive Maintenance', 'menu-icon fa-duotone fa-screwdriver-wrench text-primary', '', this.preventiveMaintenance),
    new SidebarItem(14, 'System Settings', 'menu-icon fa-duotone fa-gear', '', this.systemSettings),
    new SidebarItem(15, 'Coming Soon', 'menu-icon fa-duotone fa-clock text-secondary', '', this.comingSoon, null, null, ''),
  ];
  //#endregion

  //#region Constructor
  constructor(private _router: Router, private _activatedRoute: ActivatedRoute) {
    _router.events.subscribe((val) => {
      this.current_href = this._router.url;
      this.removeAllActiveStatus();
      this.setActiveStatus(this.current_href.replace('/app/', ''));
    });
  }
  //#endregion

  //#region Input & Output

  //#endregion

  //#region lifecycle hook Methods
  ngOnInit(): void {
    //NGRX
    const user = localStorage.getItem('currentUser');
    if (user) {
      const parsed = JSON.parse(user);
      this.role_name = parsed.role_name;
      this.userModules = parsed.module_permissions || {};
      if(!this.isSadinAdmin()){
        this.filterSidebarItems()
      }
    }
  }
  ngAfterViewInit(): void {
    this.setAll();
    this.menuAssist.update(); // Helpers.update();
    this.menuAssist.mainMenu.update(); // Helpers.mainMenu.update();
    // (window as any).templateCustomizer.update();
  }
  ngOnDestroy() {
    // this.ngUnsubscribe$.next();
    // this.ngUnsubscribe$.complete();
  }
  //#endregion

  //#region HTML Events
  public selectSidebarItem(item: SidebarItem, parent: SidebarItem = null, grandParent: SidebarItem = null): void {
    if (item.childItems.length > 0) {
      item.showChild = !item.showChild;
      return;
    }
    this.removeAllActiveStatus();
    item.isActive = true;
    if (parent) {
      parent.isActive = true;
    }
    if (grandParent) {
      grandParent.isActive = true;
    }
    let routes: string[] = [];
    this.addRoutes(item.route, routes);
    this._router.navigate(routes, { relativeTo: this._activatedRoute });
    this.selected_route = item.route;
  }
  public selectChildSidebarItem(item: SidebarItem, parentItem: SidebarItem): void {
    if (item.childItems.length > 0) {
      item.showChild = !item.showChild;
    }
    let routes: string[] = [];
    // this.addRoutes(parentItem.route, routes);
    this.addRoutes(item.route, routes);
    this._router.navigate(routes, { relativeTo: this._activatedRoute });
  }
  public setAll(): void {
    // Initialize menu
    //-----------------
    let templateName = document.documentElement.getAttribute('data-template')
    let isHorizontalLayout = false;
    if (document.getElementById('layout-menu')) {
      isHorizontalLayout = document.getElementById('layout-menu').classList.contains('menu-horizontal');
    }
    let layoutMenuEl = document.querySelectorAll('#layout-menu');
    layoutMenuEl.forEach((element) => {
      let menu = new Menu(element, {
        orientation: isHorizontalLayout ? 'horizontal' : 'vertical',
        closeChildren: isHorizontalLayout ? true : false,
        // ? This option only works with Horizontal menu
        showDropdownOnHover: true
        // showDropdownOnHover: localStorage.getItem('templateCustomizer-' + templateName + '--ShowDropdownOnHover') // If value(showDropdownOnHover) is set in local storage
        //   ? localStorage.getItem('templateCustomizer-' + templateName + '--ShowDropdownOnHover') === 'true' // Use the local storage value
        //   : (window as any).templateCustomizer !== undefined // If value is set in config.js
        //     ? (window as any).templateCustomizer.settings.defaultShowDropdownOnHover // Use the config.js value
        //     : true // Use this if you are not using the config.js and want to set value directly from here
      });
      // Change parameter to true if you want scroll animation
      this.menuAssist.scrollToActive((false)); // (window as any).Helpers.scrollToActive((false));
      this.menuAssist.mainMenu = menu; // (window as any).Helpers.mainMenu = menu;
    });

    // Initialize menu togglers and bind click on each
    let menuToggler = document.querySelectorAll('.layout-menu-toggle');
    menuToggler.forEach(item => {
      item.addEventListener('click', event => {
        event.preventDefault();
        this.menuAssist.toggleCollapsed();
        // Enable menu state with local storage support if enableMenuLocalStorage = true from config.js
        if (!this.menuAssist.isSmallScreen()) {
          try {
            localStorage.setItem(
              'templateCustomizer-' + templateName + '--LayoutCollapsed',
              String(this.menuAssist.isCollapsed())
            );
          } catch (e) { }
        }
      });
    });

    // Menu swipe gesture

    // Detect swipe gesture on the target element and call swipe In
    this.menuAssist.swipeIn('.drag-target', (e) => {
      this.menuAssist.setCollapsed(false);
    });

    // Detect swipe gesture on the target element and call swipe Out
    this.menuAssist.swipeOut('#layout-menu', (e) => {
      if (this.menuAssist.isSmallScreen()) this.menuAssist.setCollapsed(true);
    });

    // Display in main menu when menu scrolls
    let menuInnerContainer = document.getElementsByClassName('menu-inner'),
      menuInnerShadow: any = document.getElementsByClassName('menu-inner-shadow')[0];
    if (menuInnerContainer.length > 0 && menuInnerShadow) {
      menuInnerContainer[0].addEventListener('ps-scroll-y', function () {
        if (this.querySelector('.ps__thumb-y').offsetTop) {
          menuInnerShadow.style.display = 'block';
        } else {
          menuInnerShadow.style.display = 'none';
        }
      });
    }
  }
  private removeAllActiveStatus(): void {
    this.sidebarItems.forEach(item => {
      item.isActive = false;
      item.isOpen = false;
      item.childItems.forEach(child => {
        child.isActive = false;
        child.isOpen = false;
        child.childItems.forEach(secondChild => {
          secondChild.isActive = false;
          secondChild.isOpen = false;
        });
      });
    });
  }
  private setActiveStatus(current_route: string): void {
    let selectedFound: boolean = false;
    this.sidebarItems.forEach(item => {
      item.childItems.forEach(child => {
        child.childItems.forEach(secondChild => {
          secondChild.isActive = this.checkRouteMatch(current_route, secondChild.route);
          if (secondChild.isActive) {
            item.isActive = true;
            item.isOpen = true;
            child.isActive = true;
            child.isOpen = true;
            selectedFound = true;
          }
        });
      });
    });
    if (!selectedFound) {
      this.sidebarItems.forEach(item => {
        item.childItems.forEach(child => {
          child.isActive = this.checkRouteMatch(current_route, child.route);
          if (child.isActive) {
            item.isActive = true;
            item.isOpen = true;
            selectedFound = true;
          }
        });
      });
    }
    if (!selectedFound) {
      this.sidebarItems.forEach(item => {
        item.isActive = this.checkRouteMatch(current_route, item.route);
        if (item.isActive) {
          item.isOpen = true;
          selectedFound = true;
        }
      });
    }
  }
  private checkRouteMatch(current_route: string, menuRoute: string): boolean{
    if (!menuRoute) return false;
    const normalizedCurrentRoute = current_route.split(/[?#]/)[0].replace(/^\/+|\/+$/g, '');
    const normalizedMenuRoute = menuRoute.replace(/^\/+|\/+$/g, '');
    return normalizedCurrentRoute === normalizedMenuRoute || normalizedCurrentRoute.startsWith(`${normalizedMenuRoute}/`);
  }


  private filterSidebarItems(): void {
  const hasAccess = (key: string): boolean => key ? this.userModules[key]?.read === true : true;
  const hasRoleAccess = (item: SidebarItem): boolean =>
    item.allowedRoles.length === 0 || item.allowedRoles.some(role => this.isRole(role));

  const filterItems = (items: SidebarItem[]): SidebarItem[] => {
    return items
      .map(item => {
        const filteredChildren = filterItems(item.childItems);
        const canShowSelf = item.allowedRoles.length > 0 ? hasRoleAccess(item) : hasAccess(item.moduleKey);
        const canShow = canShowSelf || filteredChildren.length > 0;
        return canShow
          ? new SidebarItem(
              item.id,
              item.label,
              item.icon,
              item.route,
              filteredChildren,
              item.iconColor,
              item.showChild,
              item.moduleKey,
              item.allowedRoles
            )
          : null;
      })
      .filter(Boolean) as SidebarItem[];
  };

  this.sidebarItems = filterItems(this.sidebarItems);
}

  private isSadinAdmin(): boolean {
    return this.isRole('SADIN-ADMIN');
  }

  private isRole(roleName: string): boolean {
    return this.role_name?.toLowerCase() === roleName.toLowerCase();
  }


  //#endregion

  //#region Api Methods

  //#endregion

  //#region Private Methods
  private addRoutes(route: string | null, routes: string[]) {
    if (route) {
      routes.push(route);
    }
  }
  //#endregion
}
